import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-appid-209838-1",
  "use": "icon-appid-209838-1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-appid-209838-1\">\n  <g clip-path=\"url(#icon-appid-209838-1_clip0_1884_3573)\">\n    <rect x=\"2\" y=\"2\" width=\"16\" height=\"16\" rx=\"3\" fill=\"#BDC9F2\" />\n    <path d=\"M5.5 13L9.5 9L11 11L14.5 8\" stroke=\"#3859B0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  </g>\n  <defs>\n    <clipPath id=\"icon-appid-209838-1_clip0_1884_3573\">\n      <rect width=\"20\" height=\"20\" fill=\"white\" />\n    </clipPath>\n  </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol